import React, { useState, useEffect } from "react";
import Navbar from "react-bootstrap/Navbar";
import Container from "react-bootstrap/Container";
import UserWayAccessibilityMenu from "./UserWayAccessibilityMenu";
import "../App.css";

export default function Navheader(props) {
  const [navbar, setNavbar] = useState(false);

  useEffect(() => {
    const changeBackground = () => {
      if (window.scrollY >= 9) {
        setNavbar(true);
      } else {
        setNavbar(false);
      }
    };

    window.addEventListener("scroll", changeBackground);
    return () => {
      window.removeEventListener("scroll", changeBackground);
    };
  }, []);

  return (
    <Navbar
      collapseOnSelect
      expand="lg"
      fixed="top"
      bg="dark"
      variant="dark"
      className={navbar ? "navbar active" : "navbar"}
    >
      <Container className="d-flex justify-content-between align-items-center w-100">
        {/* Logo aligned to the left */}
        <Navbar.Brand>
          <a
            href="https://www.swmc.com/"
            target="_blank"
            rel="noreferrer noopener"
            title="https://www.swmc.com"
          >
            <img
              src="https://resources.swmc.com/swmc-images/sunwest-trust-white-logo.png"
              className="img-fluid w-50 main_logo"
              alt="swmc-logo"
            />
          </a>
        </Navbar.Brand>

        {/* Accessibility icon aligned to the right */}
        <UserWayAccessibilityMenu color="white" width={40} height={40} />
      </Container>
    </Navbar>
  );
}
